<template>
  <component v-if="enabled && resolved"
             :is="resolved"
             v-bind="$attrs"
             v-on="$listeners"/>
  <div v-else-if="enabled && !resolved" class="alert alert-warning">
    {{ $t('core.error') }}: unknown section "{{ name }}"
  </div>
</template>

<script>
import SectionApprovals from './sections/SectionApprovals.vue'
import SectionBankData from './sections/SectionBankData.vue'
import SectionEducational from './sections/SectionEducational.vue'
import SectionFiles from './sections/SectionFiles.vue'
import SectionGeneral from './sections/SectionGeneral.vue'
import SectionInvoicing from './sections/SectionInvoicing.vue'
import SectionItems from './sections/SectionItems.vue'
import SectionKamAddresses from './sections/SectionKamAddresses.vue'
import SectionKamItemProofs from './sections/SectionKamItemProofs.vue'
import SectionKuko from './sections/SectionKuko.vue'
import SectionMultiYear from './sections/SectionMultiYear.vue'
import SectionPdf from './sections/SectionPdf.vue'
import SectionPlanData from './sections/SectionPlanData.vue'
import SectionVerification from './sections/SectionVerification.vue'

const SECTIONS = {
  SectionApprovals,
  SectionBankData,
  SectionEducational,
  SectionFiles,
  SectionGeneral,
  SectionInvoicing,
  SectionItems,
  SectionKamAddresses,
  SectionKamItemProofs,
  SectionKuko,
  SectionMultiYear,
  SectionPdf,
  SectionPlanData,
  SectionVerification
}

export default {
  name: 'ContractSection',
  inheritAttrs: false,
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    resolved() {
      return SECTIONS[this.name] || null
    }
  }
}
</script>
